import React from 'react';
import {SYNTH_TYPES} from 'constants/synth-types.js';
import Colors from 'components/Colors.js';

const HEIGHT = 15;
const WIDTH = 15;

const colors = new Colors();

const PresetIcon = ({preset}) => {
    let title = preset.title.toLowerCase();
    let tags = preset.tags;
    let type = undefined;
    for (let _type of SYNTH_TYPES) {
        if (title.includes(_type)) {
            type = _type
        } else if (tags.some(t => t.includes(_type))) {
            type = _type
        }
    }
    if (!type && tags.length > 0) {
        type = tags[0];
    }

    let color = type ? colors.getColorForHash(type) :
        'gray';
    return (
        <div style={{borderBottomColor: color}} className="preset-type"></div>
    );
};

export default PresetIcon;
